import React from "react";
import "./Quote.css";
const Quote = () => {
  return (
    <div>
      <section class="quote">
        <div class="container">
          <h2>Get Your Free Quote Today</h2>
          <p>Choose us and experience excellence firsthand</p>

          <button>Get Free Quote</button>
        </div>
      </section>
    </div>
  );
};

export default Quote;
